module.exports = __webpack_public_path__ + "media/npc_dota_hero_dragon_knight.ce89712b.webm";